<div class="about">
  <div class="section-title" style="padding-top: 20px; padding-bottom: 20px;">
    <h2>
      All the entries in Category <b>{{ gradeCategoryName }}</b> for DART Student Art Contest <b>{{ year }}</b>.
    </h2>
    <p style="text-align: left">
      Click on the heart icon for an image to mark it as a favorite. That artwork will move to the top of the category for easy reference.
    </p>
    <p style="text-align: left">
      To submit your votes for this category, simply drag and drop your selection into the 1st, 2nd, or 3rd place box.  To change your selection, drag the artwork back into the gallery. Then move the new selection into the correct box.
    </p>
    <p style="text-align: left">
      You can change your selection at any time up to the deadline. All votes must be submitted by Thursday, May 5 at 5:30 PM.
    </p>
  </div>

  <div cdkDropListGroup>
    <div class="choice-container">
      <h3>1st Place Choice</h3>
      <div cdkDropList
           #choice1List="cdkDropList"
           id="cdkListChoice1"
           [cdkDropListData]="choice1"
           [cdkDropListConnectedTo]="[pictureGalleryList]"
           class="choice-list"
           (cdkDropListDropped)="dropChoice1($event)">
        <div class="picture-box" *ngFor="let item of choice1" cdkDrag>
          <img [src]="item.pictureThumbName" />
        </div>
      </div>
    </div>

    <div class="choice-container">
      <h3>2nd Place Choice</h3>

      <div cdkDropList
           #choice2List="cdkDropList"
           id="cdkListChoice2"
           [cdkDropListData]="choice2"
           [cdkDropListConnectedTo]="[pictureGalleryList]"
           class="choice-list"
           (cdkDropListDropped)="dropChoice2($event)">
        <div class="picture-box" *ngFor="let item of choice2" cdkDrag>
          <img [src]="item.pictureThumbName" />
        </div>
      </div>
    </div>

    <div class="choice-container">
      <h3>3rd Place Choice</h3>
      <div cdkDropList
           #choice3List="cdkDropList"
           id="cdkListChoice3"
           [cdkDropListData]="choice3"
           [cdkDropListConnectedTo]="[pictureGalleryList]"
           class="choice-list"
           (cdkDropListDropped)="dropChoice3($event)">
        <div class="picture-box" *ngFor="let item of choice3" cdkDrag>
          <img [src]="item.pictureThumbName" />
        </div>
      </div>
    </div>
    <div class="choice-button-container">
      <button mat-raised-button color="primary" (click)="saveContestVote()">Submit</button>
    </div>

    <div>
      <h3>Gallery</h3>
      <div cdkDropList
           #pictureGalleryList="cdkDropList"
           [cdkDropListData]="pictureGallery"
           [cdkDropListConnectedTo]="[choice1List,choice2List,choice3List]"
           class="picture-list"
           (cdkDropListDropped)="galleryDrop($event)">

        <mat-paginator #topPaginator [length]="length"
                       [pageSize]="pageSize"
                       [pageSizeOptions]="pageSizeOptions"
                       showFirstLastButtons
                       (page)="OnPageChange($event)">
        </mat-paginator>

        <mat-grid-list cols="4" rowHeight="1:1">
          <mat-grid-tile *ngFor="let item of pictureGallery">
            <div class="member" data-aos="zoom-in" data-aos-delay="100">
              <div class="member-info">
                <div class="social" style="text-align: right;">
                  <button mat-icon-button color="warn" (click)="setFavorite(item)" style="display: inline-block;">
                    <mat-icon *ngIf="item.isFavorite">
                      favorite
                    </mat-icon>
                    <mat-icon *ngIf="!item.isFavorite">
                      favorite_border
                    </mat-icon>

                  </button>
                </div>
              </div>
              <div cdkDrag>
                <img [src]="item.pictureThumbName"
                     class="img-fluid"
                     alt=""
                     (mousedown)="dragImage(item.contestEntryId)"
                     (click)="open(item)">
              </div>
            </div>
          </mat-grid-tile>
        </mat-grid-list>

        <mat-paginator (page)="setBottomPaginator($event)"
                       [length]="topPaginator.length"
                       [pageSize]="topPaginator.pageSize"
                       [pageSizeOptions]="topPaginator.pageSizeOptions"
                       [pageIndex]="topPaginator.pageIndex"
                       showFirstLastButtons>

        </mat-paginator>
      </div>
    </div>
  </div>
</div>

<ngx-spinner [fullScreen]="true" type="square-jelly-box" size="medium">
  <p class="loading">Loading ...</p>
</ngx-spinner>
